let prevScrollposHeaderHidden = window.pageYOffset;

function switchHeader() {
    const currentScrollPos = window.pageYOffset;
    const directionUp = prevScrollposHeaderHidden > currentScrollPos;

    if (directionUp || currentScrollPos <= 95) {
        document.querySelector('.header').classList.remove('header--hidden');
    } else {
        if (!document.body.classList.contains('-search-open')) {
            document.querySelector('.header').classList.add('header--hidden');
        }
    }
    prevScrollposHeaderHidden = currentScrollPos;
}

window.addEventListener('scroll', switchHeader, { passive: true });

// HEADER ON TOP:
const headerEl = document.querySelector('.header');

if (headerEl.offsetTop === 15 && document.documentElement.scrollTop === 0) {
    headerEl.classList.add('header--on-top');
}

let prevScrollposHeaderOnTop = window.pageYOffset;
function fixHeaderOnScroll() {
    const currentScrollPos = window.pageYOffset;
    const directionUp = prevScrollposHeaderOnTop > currentScrollPos;

    if (currentScrollPos === 0) {
        headerEl.classList.add('header--on-top');
    } else if (directionUp) {
        headerEl.classList.remove('header--on-top');
    }

    prevScrollposHeaderOnTop = currentScrollPos;
}

window.addEventListener('scroll', fixHeaderOnScroll, { passive: true });

//SERVICE DROPDOWN:

const desktopServiceIcon = document.querySelector('.header-right__services');
const mobileServiceIcon = document.querySelector('.mobile-nav-bottom__services');
const desktopService = document.querySelector('.header-service--desktop');
const mobileService = document.querySelector('.header-service--mobile');
const header = document.querySelector('.header');

if (desktopServiceIcon && desktopService && mobileServiceIcon && mobileService) {
    desktopServiceIcon.addEventListener('click', () => {
        if (desktopService.style.display === 'none' || desktopService.style.display === '') {
            desktopService.style.display = 'block';
            desktopServiceIcon.classList.add('service-open');
            header.classList.add('service-open');
        } else {
            desktopService.style.display = 'none';
            desktopServiceIcon.classList.remove('service-open');
            header.classList.remove('service-open');
        }
    });

    mobileServiceIcon.addEventListener('click', () => {
        if (mobileService.style.display === 'none' || mobileService.style.display === '') {
            mobileService.style.display = 'block';
            mobileServiceIcon.classList.add('service-open');
            header.classList.add('service-open');
        } else {
            mobileService.style.display = 'none';
            mobileServiceIcon.classList.remove('service-open');
            header.classList.remove('service-open');
        }
    });
    desktopService.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    mobileService.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    document.addEventListener('click', (event) => {
        if (
            window.innerWidth > 1025 &&
            !desktopServiceIcon.contains(event.target) &&
            !desktopService.contains(event.target)
        ) {
            desktopService.style.display = 'none';
            desktopServiceIcon.classList.remove('service-open');
            header.classList.remove('service-open');
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth <= 1025) {
            if (desktopService.style.display === 'block') {
                desktopService.style.display = 'none';
                desktopServiceIcon.classList.remove('service-open');
                header.classList.remove('service-open');
            }
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > 1025) {
            if (mobileService.style.display === 'block') {
                mobileService.style.display = 'none';
                mobileServiceIcon.classList.remove('service-open');
                header.classList.remove('service-open');
            }
        }
    });
}

// SEARCH DROPDOWN:
const searchIcon = document.querySelector('.header-right__search');
const mobileSearchIcon = document.querySelector('.mobile-nav-bottom__search');
const headerSearchEl = document.querySelector('.header-search');
const headerSearchInputEl = document.querySelector('.header-search__input');

if (headerEl && headerSearchEl && searchIcon && mobileSearchIcon) {
    [searchIcon, mobileSearchIcon].forEach((icon) => {
        icon.addEventListener('click', () => {
            headerSearchEl.classList.toggle('header-search--open');
            searchIcon.classList.toggle('header-right__search--open');
            mobileSearchIcon.classList.toggle('mobile-nav-bottom__search--open');
            header.classList.toggle('search-open');

            if (headerSearchInputEl) {
                headerSearchInputEl.focus();
            }
        });
    });

    headerSearchEl.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    document.addEventListener('click', (event) => {
        if (
            !headerSearchEl.contains(event.target) &&
            ![searchIcon, mobileSearchIcon].some((icon) => icon.contains(event.target))
        ) {
            headerSearchEl.classList.remove('header-search--open');
            searchIcon.classList.remove('header-right__search--open');
            mobileSearchIcon.classList.remove('mobile-nav-bottom__search--open');
            headerEl.classList.remove('search-open');
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth < 1025) {
            if (headerSearchEl.classList.contains('header-search--open')) {
                document.body.classList.add('-menuopen');
                document.querySelector('html')?.classList.add('-menuopen');
            }
        }
    });
}
